import React, { memo } from 'react';
import styled from 'styled-components';
const StyledRadar = styled.a `
  white-space: nowrap;
`;
export const RadarLink = memo(({ text = 'File a Radar', radar = {}, url }) => {
    const queryString = Object.keys(radar)
        .map((key) => `${key}=${encodeURIComponent(radar[key])}`)
        .join('&');
    return (React.createElement(StyledRadar, { target: "_blank", href: url || `rdar://new/problem/${queryString}` }, text));
});
